import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q5pzuy3y7: FaireProductEntity = {
  token: "p_2q5pzuy3y7",
  type: "product",
  name: "Evil Eye Talisman Tag Pendenat 14K Gold Steel Necklace",
  brandToken: "b_sf3pyfue5x",
  brandName: "HoopLa",
  imageUrl:
    "https://cdn.faire.com/fastly/22b4ff00edcf4e838a5bc66791e8ab24f8f0997e64e0e7b7bfd74221e186a993.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f13d0941992f6b8c3c088f0a7177ff945485e0fa0e3729c14c62124733e37d25.jpeg",
    "https://cdn.faire.com/fastly/244e2a01ae8c2227ca5a8e05a0115fcbd3eb616f721a1f92e136ae5d9af51eeb.jpeg",
    "https://cdn.faire.com/fastly/a6228e850d3a2c126a478097a4a5c5bc60fd1af7ee46bcb4a4f8e542ecc59e75.png",
    "https://cdn.faire.com/fastly/819ee1ca065acb0f8fdd3eff2fc86bf334aed5960534dd96aa32e22907f19826.jpeg",
    "https://cdn.faire.com/fastly/ee40d16a58922106ec75bb18bd99a7d35e27566bec8d549d2c632b5926135d23.jpeg",
    "https://cdn.faire.com/fastly/a68be8e88cf047460d4c40d4a74e90566fc4ef7931cd4c86d3d57a8b499ef0d8.jpeg",
    "https://cdn.faire.com/fastly/9b1b83bbb5ff4ed4c6dcdc1eb0df90abdf33fc56481b4f35d193dbad20beaec5.jpeg",
    "https://cdn.faire.com/fastly/93a47889bbcfa744851c1afb18c1d0002b5455a15885e48d39f59275a0a370d0.jpeg",
    "https://cdn.faire.com/fastly/e5b1ca586a1214600aa8838f4491d1f03a594eb02c84689bdb1c3baa430695c6.png",
  ],
  priceDollars: 20.55,
  description:
    "Evil Eye Protective Dog Tag Sun ray Talisman Style Necklace. 3D Pave Evil Eye set on a Sun Ray Laser Etched Dod Tag Style Necklace. Protective. Ancient blessings. \nCast steel. Dipped in Genuine 14K Gold Plating. Making it waterproof. Tarnish resistant and Hypoallergenic. CZ crystals hand se and prong closed\nLobster Claw Clasp. ",
  tags: [],
  msrpDollars: 41.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:34.438Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
